export default "__VITE_ASSET__a475b676__"